import React, { Component, Fragment } from "react";
import BlockUi from "react-block-ui";
import $ from "jquery";
import "react-block-ui/style.css";
import Logo from "../logo.png";
import "../CSS/Login.css";

class login extends Component {
  state = {
    blocking: false,
    mobile: "",
    code: "",
    time_remaining: 300,
    btnClass: "btn btn-primary btn-sm float-left mt-2 disabled",
    errorMessage: "",
    viewOtpForm: false,
    needCheckData: false,
    towns: [],
    city: [],
    stateId: 0,
    cityId: 0,
  };

  changeCity = (evt) => {
    this.setState({ cityId: evt.target.value });
  };

  changeState = (evt) => {
    this.setState({ stateId: evt.target.value });
    this.getCity(evt.target.value);
  };
  getCity = (townID) => {
    let currentValue = null;
    try {
      currentValue = townID.target.value;
    } catch (error) {
      currentValue = townID;
    }
    var formdata = new FormData();
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/get-cities?state_id=${currentValue}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        if (result !== null) {
          var myObject = JSON.parse(result);
          if (myObject.status === 0) {
            this.setState({ city: myObject.data });
          }
        }
      })
      .catch((error) => console.log("error", error));
  };
  toggleBlocking = () => {
    this.setState({ blocking: !this.state.blocking });
  };

  renderForm = () => {
    if (localStorage.getItem("token") !== null) return (window.location = "/");
    if (!this.state.viewOtpForm) {
      return (
        <div className="panel-login container">
          <div className="form-body row">
            <div className="login-form col align-self-center py-2">
              <div id="loginForm" className="w-100">
                <BlockUi tag="div" blocking={this.state.blocking}>
                  <div className="text-center">
                    <img
                      src={Logo}
                      className="Logo-Class"
                      alt="Dina Part"
                    ></img>
                  </div>
                  <p className="h1 mt-2">خوش آمدید!</p>
                  <p className="text-dark font-weight-bold text-justify">
                    برای عضویت در شبکه تعمیرکاران شرکت دیناپارت، شماره موبایل
                    خود را وارد کنید.
                  </p>
                  <input
                    type="text"
                    className="form-control rounded text-center NumberValid"
                    id="uname"
                    name="uname"
                    placeholder="مثلاً 09124779146"
                    maxLength={11}
                    onKeyUp={this.handleMobile}
                  ></input>
                  <p className="small text-danger mb-0">
                    {this.state.errorMessage}
                  </p>
                  <button
                    className={this.state.btnClass}
                    onClick={() => this.otp(this.state.mobile)}
                    id="sing-in-button"
                  >
                    ادامه
                  </button>
                </BlockUi>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="panel-login container">
          <div className="form-body row">
            <div className="login-form col align-self-center py-2">
              <BlockUi tag="div" blocking={this.state.blocking}>
                <p className="h1 mt-2">کد تأیید را وارد کنید.</p>
                <p className="text-dark font-weight-bold text-justify">
                  کد تأیید را به شماره {this.state.mobile} فرستادیم.
                </p>
                <p className="text-dark text-justify">
                  شماره موبایل اشتباه است؟{" "}
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => this.setState({ viewOtpForm: false })}
                  >
                    ویرایش
                  </button>{" "}
                </p>
                {this.state.needCheckData ? (
                  <Fragment>
                    <div className="w-100 alert alert-warning rounded-0">
                      <h6 className="text-justify mb-0">
                        تعمیر کار گرامی، جهت استفاده از این نرم افزار لطفاً
                        استان محل فعالیت خود را مشخص کنید.
                      </h6>
                    </div>
                    <div className="row">
                      <div className="col-6 mt-2">
                        <label className="wp-text">
                          استان<span className="text-danger mr-1">*</span>
                        </label>
                        <select
                          value={
                            this.state.stateId && this.state.stateId > 0
                              ? this.state.stateId
                              : 0
                          }
                          id="Town_ID"
                          name="Town_ID"
                          className="form-control rounded text-center valid-empty"
                          tabIndex="7"
                          onChange={this.changeState}
                        >
                          <option value="0">انتخاب نمایید</option>
                          {this.state.towns
                            ? this.state.towns.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.name}
                                </option>
                              ))
                            : null}
                        </select>
                        <div className="invalid-feedback wp-text-small"></div>
                      </div>
                      <div className="col-6 mt-2">
                        <label className="wp-text">
                          شهر<span className="text-danger mr-1">*</span>
                        </label>
                        {this.state.city ? (
                          <>
                            <select
                              value={this.state.cityId}
                              id="City_ID"
                              name="City_ID"
                              className="form-control rounded text-center valid-empty"
                              tabIndex="8"
                              onChange={this.changeCity}
                            >
                              <option value="0">
                                ابتدا استان را انتخاب نمایید.
                              </option>
                              {this.state.city.map((e) => (
                                <option key={e.id} value={e.id}>
                                  {e.name}
                                </option>
                              ))}
                            </select>
                            <div className="invalid-feedback wp-text-small"></div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </Fragment>
                ) : null}
                <div className="col-12 mt-2">
                  <label className="wp-text">
                    کد اعتبارسنجی<span className="text-danger mr-1">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control rounded text-center NumberValid"
                    id="code"
                    name="code"
                    maxLength={4}
                    onKeyUp={this.handleCode}
                  ></input>
                  <p className="small text-danger mb-0"></p>
                </div>
                <div className="col-12 text-left">
                  <button
                    className="btn btn-primary btn-sm  mt-2"
                    onClick={() => this.otpVerify(this.state.code)}
                  >
                    اعتبارسنجی
                  </button>
                </div>
                <div className="col-12 mt-2">
                  <p className="text-dark font-wieght-bold mt-2">
                    کد تأیید را نگرفته اید؟{" "}
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => this.otpVerifyAgain(this.state.mobile)}
                    >
                      ارسال مجدد
                    </button>
                  </p>
                </div>
              </BlockUi>
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    $(".NumberValid").on("input", function() {
      var e = "۰".charCodeAt(0);
      this.value = this.value.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      e = "٠".charCodeAt(0);
      this.value = this.value.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      this.value = this.value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
    });
    return <React.Fragment>{this.renderForm()}</React.Fragment>;
  }

  otp = (mobile) => {
    this.toggleBlocking();
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/user/login-request-confirmation-code?mobile=${mobile}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status === 0) {
          this.setState({
            viewOtpForm: true,
            needCheckData: result.needCheckData,
            towns: result.towns,
            time_remaining: 60,
          });
        } else {
          this.props.toggleErrorMessage(result.message);
          this.props.toggleError();
        }
        this.toggleBlocking();
      })
      .catch((e) => {
        this.toggleBlocking();
        this.props.toggleErrorMessage(
          "عدم امکان برقرار ارتباط با سرور، اینترنت خود را بررسی نمایید."
        );
        this.props.toggleError();
      });
  };

  otpVerify = (e) => {
    console.log(e);
    const stateId = this.state.stateId;
    const cityId = this.state.cityId;
    const needCheckData = this.state.needCheckData;
    if (needCheckData && cityId <= 0) {
      this.props.toggleErrorMessage("موقعیت مکانی خود را وارد کنید.");
      this.props.toggleError();
      return;
    }

    //const currentValue = e.target.value;
    const currentValue = e;
    if (currentValue.length === 4) {
      this.toggleBlocking();
      var formdata = new FormData();
      formdata.append("mobile", this.state.mobile);
      formdata.append("verify_code", currentValue);
      formdata.append("stateId", stateId);
      formdata.append("cityId", cityId);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/user/login-request-confirmation-code`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 0) {
            this.props.handleLogin(result);
          } else {
            this.props.toggleErrorMessage(result.message);
            this.props.toggleError();
            this.toggleBlocking();
          }
        })
        .catch((e) => {
          this.props.toggleErrorMessage(
            "عدم امکان برقرار ارتباط با سرور، اینترنت خود را بررسی نمایید."
          );
          this.props.toggleError();
          this.toggleBlocking();
        });
    }
  };

  otpVerifyAgain = (e) => {
    let mobile = e;
    if (mobile !== null && this.state.time_remaining === 0) {
      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/user/login-request-confirmation-code?mobile=${mobile}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 0) {
            this.setState({ viewOtpForm: true, time_remaining: 60 });
          } else {
            this.props.toggleErrorMessage(result.message);
            this.props.toggleError();
          }
        })
        .catch((e) => {
          this.props.toggleErrorMessage(
            "عدم امکان برقرار ارتباط با سرور، اینترنت خود را بررسی نمایید."
          );
          this.props.toggleError();
        });
    } else {
      this.props.toggleErrorMessage(
        "کد تأیید به تازگی برای شما ارسال شده است چند دقیقه دیگر تلاش نمایید."
      );
      this.props.toggleError();
    }
  };

  handleMobile = (e) => {
    const currentValue = e.target.value;
    this.setState({ mobile: currentValue });
    var phoneno = /^[0][9][0-9]{9}/;
    if (currentValue.match(phoneno)) {
      this.setState({ btnClass: "btn btn-sm btn-primary mt-2 float-left" });
      this.setState({ errorMessage: "" });
    } else {
      this.setState({ btnClass: "btn btn-sm btn-primary float-left disabled" });
      const errorMessage =
        this.state.mobile.length === 0
          ? "شماره موبایل خود را وارد نمایید."
          : "شماره موبایل وارد شده اشتباه است.";
      this.setState({ errorMessage: errorMessage });
    }
  };
  handleCode = (e) => {
    const currentValue = e.target.value;
    this.setState({ code: currentValue });
  };
}

export default login;
